import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { LabTestResult } from '../../lab-test-results';
import { SponsorSelectedSubjectLabResultsStorage } from './sponsor-selected-subject-lab-results-storage';

@Component({
    selector: 'sponsor-subject-lab-tests-grid',
    template: require('./sponsor-subject-lab-tests-grid.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorSubjectLabTestsGridComponent {
    public readonly data: Observable<LabTestResult[]>;

    constructor(labResultsStorage: SponsorSelectedSubjectLabResultsStorage) {
        this.data = labResultsStorage.labTestResults;
    }
}